import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { OrganizationService } from 'src/app/private/services/organization.services';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-create-role',
  imports: [SharedModule],
  templateUrl: './create-role.component.html',
  styleUrls: ['./create-role.component.scss'],
})
export class CreateRoleComponent {
  permissionForm!: FormGroup;
  @Input() orgId!: string;
  @Input() roleDataToEdit: any = null; // To hold the role data to be edited
  @Input() type: string = ''; // To hold the type of the role (e.g., 'create', 'edit')
  selectedModuleIndex: number = 0;
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>(); // Event emitter to notify parent component for reloading data

  isOpenAddModule: boolean = false; // Flag to control the visibility of the add module dialog
  moduleForm: FormGroup;
  btnLoading: boolean = false; // Loading state for the button
  constructor(private fb: FormBuilder,
    private organizationService: OrganizationService,
    private messageService: MessageService
  ) {
    this.moduleForm = this.fb.group({
      title: ['', Validators.required],
      module_name: ['', Validators.required],
      features: this.fb.array([]),
    });
  }



  ngOnInit() {
    this.permissionForm = this.fb.group({
      organization_id: [this.orgId], // Organization ID passed from the parent component
      name: ['', Validators.required],
      status: ['Active', Validators.required],
      permission: this.fb.array([]),
    });


    if (this.type === 'Update' && this.roleDataToEdit) {
      console.log(this.roleDataToEdit);
      this.permissionForm.patchValue(this.roleDataToEdit);

      this.permissionArray.clear(); // Clear the existing permission array before setting new values

      this.roleDataToEdit.permission.forEach((module: any) => {
        const featuresFormArray = this.fb.array(
          module.features.map((feature: any) =>
            this.fb.group({
              name: [feature.name],
              title: [feature.title],
              active: [feature.active],
              create: [feature.create],
              delete: [feature.delete],
              update: [feature.update],
            })
          )
        );

        this.permissionArray.push(
          this.fb.group({
            id: [module.id],
            title: [module.title],
            active: [module.active],
            features: featuresFormArray,
            module_name: [module.module_name],
          })
        );
      });
      this.selectedModuleIndex = 0; // Reset the selected module index to the first module
    } else {
      this.setInitialPermissions();
    }

  }

  get permissionArray(): any {
    return this.permissionForm.get('permission') as FormArray;
  }

  setInitialPermissions() {
    const permissionsData = [
      {
        id: 1,
        title: 'Dashboard',
        active: false,
        features: [
          { name: 'analytics', title: 'Analytics', active: false, create: false, delete: false, update: false },
          { name: 'lead', title: 'Leads', active: true, create: true, delete: true, update: true },
          { name: 'registration', title: 'Registration', active: true, create: true, delete: true, update: true },
          { name: 'application', title: 'Application', active: true, create: true, delete: true, update: true },
          { name: 'finance', title: 'Finance', active: false, create: false, delete: false, update: true },
        ],
        module_name: 'dashboard',
      },
      {
        id: 2,
        title: 'Leads',
        active: true,
        features: [
          { name: 'manual', title: 'Manual', active: true, create: true, delete: true, update: true },
        ],
        module_name: 'lead',
      },
      {
        id: 3,
        title: 'Settings',
        active: true,
        features: [
          { name: 'user', title: 'Users', active: true, create: true, delete: true, update: true },
          { name: 'leads_field_setting', title: 'Leads field Settings', active: true, create: true, delete: true, update: true },
          { name: 'whatsapp_template', title: 'Whatsapp Template', active: true, create: true, delete: true, update: true },
          { name: 'email_template', title: 'Email Template', active: true, create: true, delete: true, update: true },
          { name: 'contact_group', title: 'Contact Group', active: true, create: true, delete: true, update: true },
        ],
        module_name: 'setting',
      },
      {
        id: 4,
        title: 'Registration',
        active: true,
        features: [
          { name: 'manual', title: 'Manual', active: true, create: true, delete: true, update: true },
        ],
        module_name: 'registration',
      },
      {
        id: 5,
        title: 'Campaign',
        active: true,
        features: [
          { name: 'manual', title: 'Manual', active: true, create: true, delete: true, update: true },
        ],
        module_name: 'campaign',
      },
      {
        id: 6,
        title: 'Application',
        active: true,
        features: [
          { name: 'manual', title: 'Manual', active: true, create: true, delete: true, update: true },
        ],
        module_name: 'application',
      },
      {
        id: 7,
        title: 'Counsellor Bot',
        active: true,
        features: [],
        module_name: 'counsellor_bot',
      },
    ];


    permissionsData.forEach((module) => {
      const featuresFormArray = this.fb.array(
        module.features.map((feature) =>
          this.fb.group({
            name: [feature.name],
            title: [feature.title],
            active: [feature.active],
            create: [feature.create],
            delete: [feature.delete],
            update: [feature.update],
          })
        )
      );

      this.permissionArray.push(
        this.fb.group({
          id: [module.id],
          title: [module.title],
          active: [module.active],
          features: featuresFormArray,
          module_name: [module.module_name],
        })
      );
    });
  }


  submit() {
    if (this.type === 'Update') {
      console.log(this.permissionForm.value);
      this.btnLoading = true; // Set loading state to true
      this.permissionForm.value.id = this.roleDataToEdit.id; // Add role ID for update
      this.organizationService.updateRole(this.permissionForm.value).subscribe({
        next: (res) => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Role updated successfully!' }); // Show success message
          this.btnLoading = false; // Set loading state to false
          this.reload.emit(); // Emit reload event to parent component
          this.close.emit(); // Emit close event to parent component
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update role!' }); // Show error message
          this.permissionForm.reset(); // Reset the form
          this.permissionArray.clear(); // Clear the permission array
          this.btnLoading = false; // Set loading state to false
          console.error('Error creating role:', err); // Log error message
        },
      });
    } else {
      console.log(this.permissionForm.value);
      this.btnLoading = true; // Set loading state to true
      this.organizationService.createRole(this.permissionForm.value).subscribe({
        next: (res) => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Role created successfully!' }); // Show success message
          this.btnLoading = false; // Set loading state to false
          this.reload.emit(); // Emit reload event to parent component
          this.close.emit(); // Emit close event to parent component
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create role!' }); // Show error message
          this.permissionForm.reset(); // Reset the form
          this.permissionArray.clear(); // Clear the permission array
          this.btnLoading = false; // Set loading state to false
          console.error('Error creating role:', err); // Log error message
        },
      });
    }
  }

  selectModule(index: number) {
    this.selectedModuleIndex = index;
  }

  getFeaturesControls(index: number): FormArray {
    return this.permissionArray.at(index).get('features') as FormArray;
  }

  getControl(formGroup: any, controlName: string): any {
    return formGroup.get(controlName) as any;
  }

  handleCloseDialog() {
    this.close.emit();
  }

  openAddModule() {
    // const newModule = this.fb.group({
    //   id: [this.permissionArray.length + 1],
    //   title: [''],
    //   active: [false],
    //   features: this.fb.array([]),
    //   module_name: [''],
    // });

    // this.permissionArray.push(newModule);
    // this.selectedModuleIndex = this.permissionArray.length - 1; // Select the newly added module
    this.isOpenAddModule = true; // Open the add module dialog
  }

  permissionsData: any[] = [];


  createFeatureFormGroup(): FormGroup {
    return this.fb.group({
      name: ['', Validators.required],
      title: ['', Validators.required],
      active: [false],
      create: [false],
      update: [false],
      delete: [false],
    });
  }

  get features(): FormArray {
    return this.moduleForm.get('features') as FormArray;
  }

  addFeature() {
    this.features.push(this.createFeatureFormGroup());
  }

  removeFeature(index: number) {
    this.features.removeAt(index);
  }

  addModule() {
    // if (this.moduleForm.invalid) return;

    const newModule = {
      id: this.permissionsData.length + 1,
      title: this.moduleForm.value.title,
      module_name: this.moduleForm.value.module_name,
      active: false,
      features: this.moduleForm.value.features,
    };

    this.permissionArray.push(
      this.fb.group({
        id: [newModule.id],
        title: [newModule.title],
        active: [newModule.active],
        features: this.fb.array(
          newModule.features.map((feature: any) =>
            this.fb.group({
              name: [feature.name],
              title: [feature.title],
              active: [feature.active],
              create: [feature.create],
              delete: [feature.delete],
              update: [feature.update],
            })
          )
        ),
        module_name: [newModule.module_name],
      })
    );
    this.selectedModuleIndex = this.permissionArray.length - 1; // Select the newly added module
    this.permissionsData.push(newModule); // Add the new module to the permissions data array
    console.log('Permissions Updated:', this.permissionsData);
    this.closeIsAddModule(); // Close the add module dialog
  }

  closeIsAddModule() {
    this.isOpenAddModule = false; // Close the add module dialog
    this.moduleForm.reset(); // Reset the module form
    this.features.clear(); // Clear the features array in the module form
  }
}
